export enum AptAddressType {
    Spedizione = 'SPEDIZIONE',
    Fornitura = 'FORNITURA',
}
